// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
export const ReviewsAggregateFragmentDoc = gql`
    fragment reviewsAggregate on ReviewsAggregate {
  rating
  total
}
    `;